import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { AuthResponseInterface } from '../interfaces/auth-response-interface';
import { environment } from '../../environments/environment';
import { ILogoutResponse } from '../interfaces/ILogoutResponse';

@Injectable({
  providedIn: 'root'
})
export class Auth {

  private _http =  inject(HttpClient);
  private redirectUrl: string = '';
  private loggedin: boolean = false;

  setLogedIn(value: boolean) {
    this.loggedin = value;
  }

  getLogedIn() {
    return this.loggedin;
  }

  setRedirectUrl(url: string) {
    this.redirectUrl = url;
  }

  getUrlRedirect() {
    return this.redirectUrl;
  }

  public getCsrf(): Observable<any> {

    return this._http.get(environment.url + '/sanctum/csrf-cookie', { withCredentials: true });
  }

  public login(auth_data: any): Observable<AuthResponseInterface> {

    return this._http.post<AuthResponseInterface>(environment.url + '/api/login', auth_data).pipe(
      tap((response: AuthResponseInterface) => {

        this.setLocalStorate(response);
      })
    );
  }

  public logout(): Observable<ILogoutResponse>{

    return this._http.get<ILogoutResponse>(environment.url + '/api/logoutSistemas', { withCredentials: true });
  }

  public refreshToken(): Observable<AuthResponseInterface> {

    return this._http.post<AuthResponseInterface>(environment.url + '/api/refreshToken', { withCredentials: true }).pipe(
      tap((response: AuthResponseInterface) => {

        this.setLocalStorate(response);
      })
    );
  }

  public sendMailConfirmation($email: string): Observable<any> {

    return this._http.post(environment.url + '/api/enviaEmailConfirmacao', {email: $email}, { withCredentials: true });
  }

    public sendMailConfirmationNoAuth($email: string): Observable<any> {

      return this._http.post<AuthResponseInterface>(environment.url + '/api/enviaEmailConfirmacaoReset', {email: $email}, { withCredentials: true }).pipe(
        tap((response: AuthResponseInterface) => {

          this.setLocalStorate(response);
      })
    );
  }

  public confirmCode($code: string, $email: string): Observable<AuthResponseInterface> {

    return this._http.post<AuthResponseInterface>(environment.url + '/api/confirmaCodigo', {code: $code, email: $email}, { withCredentials: true } ).pipe(
      tap((response: AuthResponseInterface) => {

        this.setLocalStorate(response);
      })
    );
  }

  public confirmResetCode($code: string, $email: string): Observable<any> {

    return this._http.post<AuthResponseInterface>(environment.url + '/api/confirmaCodigoReset', {code: $code, email: $email}, { withCredentials: true } ).pipe(
      tap((response: AuthResponseInterface) => {

        this.setLocalStorate(response);
      })
    );
  }

  public changePassword($password: string): Observable<AuthResponseInterface> {

    return this._http.post<AuthResponseInterface>(environment.url + '/api/mudarSenha', {password: $password}, { withCredentials: true }).pipe(

      tap((response: AuthResponseInterface) => {

        this.setLocalStorate(response);
      })
    );
  }

  public resetPassword($password: string): Observable<AuthResponseInterface> {

    return this._http.post<AuthResponseInterface>(environment.url + '/api/resetaSenha', {password: $password}, { withCredentials: true }).pipe(

      tap((response: AuthResponseInterface) => {

        this.setLocalStorate(response);
      })
    );
  }

  public checkEmail($email: string): Observable<{ email: string }> {

    return this._http.post<{ email: string }>(environment.url + '/api/checaEmail', {email: $email}, { withCredentials: true });
  }

  public setSessionExpired(): void {
    sessionStorage.setItem('sessionExpired', 'true');
  }

  public consumeSessionExpired(): boolean {
    const expired = sessionStorage.getItem('sessionExpired') === 'true';
    sessionStorage.removeItem('sessionExpired');
    return expired;
  }

  public clearAuthStorage(): void {
    ['token', 'abilities', 'email_verify', 'expires', 'oldEmail'].forEach(key => {
      localStorage.removeItem(key);
    });
  }

  private setLocalStorate(response: AuthResponseInterface){

    if(response?.abilities){

      localStorage.setItem('abilities', response.abilities.join(','));
    }

    localStorage.setItem('token', response.token);
    localStorage.setItem('email_verify', response.email_verify);
    // localStorage.setItem('oldEmail', response.oldEmail!);
    localStorage.setItem('expires', new Date(new Date().getTime() + (response.expires -5) * 60000).toString() );
  }
}


